module.exports = __webpack_public_path__ + "img/map-wa.8d96229c.png";